import React from 'react';
import ChatWidget from './ChatWidget';

function App() {
  return (
    <div>
      <ChatWidget />
    </div>
  );
}

export default App;